<template>
  <pt-lab-order-lot-operate class="pt-lab-order-lot-operate__page"></pt-lab-order-lot-operate>
</template>

<script>
import PtLabOrderLotOperate from 'cps/lab-order/pt-lab-order-lot-operate/withData'
export default {
  name: 'pt-lab-order-lot-operate__view',
  components: {
    'pt-lab-order-lot-operate': PtLabOrderLotOperate
  }
}
</script>
